var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHpaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 239.238,
    height: 46.69,
    viewBox: "0 0 239.238 46.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3573",
    "data-name": "Rectangle 3573",
    width: 239.238,
    height: 46.69,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4387",
    "data-name": "Group 4387",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M0,.124V46.63H13.156V28.492H31.094V17.6H13.156V.124Z",
    transform: "translate(0 -0.067)",
    fill: "#4fc7d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4386",
    "data-name": "Group 4386",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4385",
    "data-name": "Group 4385",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M101.914,22.347a6.239,6.239,0,0,0,2.059-5.016,6.344,6.344,0,0,0-2.059-5.05q-2.06-1.793-6.113-1.793H88.493v13.62H95.8q4.052,0,6.113-1.761m5.647-20.131a16.275,16.275,0,0,1,7.175,5.98,16.4,16.4,0,0,1,2.524,9.135,16.235,16.235,0,0,1-2.524,9.1,16.348,16.348,0,0,1-7.175,5.946A26.53,26.53,0,0,1,96.6,34.472H88.493V46.63H75.338V.124H96.6a26.53,26.53,0,0,1,10.962,2.092",
    transform: "translate(-40.866 -0.067)",
    fill: "#4fc7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M177.071,12.914l5.988,14.906H171.081ZM170.682,0,150.12,46.586h13.442l3.66-9.051h19.7l3.66,9.051h13.708L183.658,0Z",
    transform: "translate(-81.43 -0.002)",
    fill: "#4fc7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M295.823,1.436V12.38h-2.033V7.689h-5.659V12.38H286.1V1.436h2.033V5.954h5.659V1.436Z",
    transform: "translate(-155.189 -0.779)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M315.273,9.022a2.332,2.332,0,0,0-.789,1.477h4.737a2.282,2.282,0,0,0-2.361-2.033,2.359,2.359,0,0,0-1.587.555M321.05,11.8H314.5a2.267,2.267,0,0,0,.9,1.462,2.945,2.945,0,0,0,1.806.539,3.043,3.043,0,0,0,2.267-.906l1.048,1.2a3.535,3.535,0,0,1-1.423,1.016,5.634,5.634,0,0,1-4.362-.2,3.938,3.938,0,0,1-1.618-1.524,4.3,4.3,0,0,1-.571-2.212,4.367,4.367,0,0,1,.555-2.2,3.935,3.935,0,0,1,1.54-1.524,4.492,4.492,0,0,1,2.22-.547,4.378,4.378,0,0,1,2.181.539,3.817,3.817,0,0,1,1.5,1.516,4.6,4.6,0,0,1,.539,2.259q0,.2-.031.578",
    transform: "translate(-169.534 -3.744)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M339,13.7a1.83,1.83,0,0,0,.805-.962v-.97h-2.017q-1.689,0-1.688,1.11a1,1,0,0,0,.422.845,1.937,1.937,0,0,0,1.173.313A2.528,2.528,0,0,0,339,13.7m1.782-5.91a3.416,3.416,0,0,1,.977,2.666v4.893h-1.844V14.329a2.273,2.273,0,0,1-1.024.836,4.009,4.009,0,0,1-1.6.289,3.926,3.926,0,0,1-1.641-.32,2.532,2.532,0,0,1-1.087-.891,2.261,2.261,0,0,1-.383-1.29,2.211,2.211,0,0,1,.837-1.806,4.151,4.151,0,0,1,2.634-.68H339.8v-.125A1.711,1.711,0,0,0,339.277,9a2.265,2.265,0,0,0-1.555-.469,4.5,4.5,0,0,0-1.384.219,3.413,3.413,0,0,0-1.149.61l-.766-1.423A4.738,4.738,0,0,1,336,7.169a7.026,7.026,0,0,1,1.954-.266,4.073,4.073,0,0,1,2.822.883",
    transform: "translate(-181.266 -3.744)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3569",
    "data-name": "Rectangle 3569",
    width: 1.954,
    height: 11.6,
    transform: "translate(163.304 0.001)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M372.042,12.816a2.3,2.3,0,0,1-.836.422,3.768,3.768,0,0,1-1.04.14,2.949,2.949,0,0,1-2.126-.719,2.769,2.769,0,0,1-.75-2.095V6.547h-1.375V4.983h1.375V3.076h1.954V4.983h2.236V6.547h-2.236v3.971a1.321,1.321,0,0,0,.3.93,1.115,1.115,0,0,0,.86.32,1.719,1.719,0,0,0,1.095-.344Z",
    transform: "translate(-198.483 -1.669)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M390.779,4.081a3.64,3.64,0,0,1,.954,2.736V11.6h-1.954V7.067a2.342,2.342,0,0,0-.516-1.649,1.906,1.906,0,0,0-1.469-.555,2.256,2.256,0,0,0-1.7.649,2.585,2.585,0,0,0-.625,1.868V11.6h-1.954V0h1.954V4.222a3.174,3.174,0,0,1,1.2-.79,4.395,4.395,0,0,1,1.587-.274,3.489,3.489,0,0,1,2.533.922",
    transform: "translate(-208.027 0)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M292.525,45.162a2.228,2.228,0,0,0,0-3.221,3.125,3.125,0,0,0-2.017-.562h-2.376v4.346h2.376a3.122,3.122,0,0,0,2.017-.563m.555-5.034a3.605,3.605,0,0,1,1.618,1.345,4.107,4.107,0,0,1,0,4.151,3.585,3.585,0,0,1-1.618,1.352,6.054,6.054,0,0,1-2.478.469h-2.47V50.6H286.1V39.659h4.5a6.054,6.054,0,0,1,2.478.469",
    transform: "translate(-155.189 -21.512)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    d: "M315.5,45.126v1.86a2.456,2.456,0,0,0-.453-.047,2.361,2.361,0,0,0-1.783.665,2.649,2.649,0,0,0-.641,1.915v4.049h-1.954V45.22h1.86v1.219a3.257,3.257,0,0,1,2.971-1.313",
    transform: "translate(-168.515 -24.478)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    d: "M330.077,51.285a2.894,2.894,0,0,0,0-3.783,2.387,2.387,0,0,0-1.782-.719,2.361,2.361,0,0,0-1.774.719,2.92,2.92,0,0,0,0,3.783,2.361,2.361,0,0,0,1.774.719,2.387,2.387,0,0,0,1.782-.719m-4.065,1.845a3.988,3.988,0,0,1-1.587-1.524,4.558,4.558,0,0,1,0-4.416,4,4,0,0,1,1.587-1.516,5.063,5.063,0,0,1,4.581,0,4,4,0,0,1,1.587,1.516,4.559,4.559,0,0,1,0,4.416,3.99,3.99,0,0,1-1.587,1.524,5.066,5.066,0,0,1-4.581,0",
    transform: "translate(-175.668 -24.477)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M348.92,40.908v.5h2.3v1.563h-2.236v6.723h-1.954V42.972h-1.376V41.409h1.376v-.532a2.847,2.847,0,0,1,.782-2.119,3.586,3.586,0,0,1,3.971-.32l-.547,1.469a1.872,1.872,0,0,0-1.079-.344q-1.236,0-1.235,1.344",
    transform: "translate(-187.493 -20.604)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    d: "M362.321,47.245a2.331,2.331,0,0,0-.79,1.477h4.737a2.282,2.282,0,0,0-2.361-2.033,2.357,2.357,0,0,0-1.586.555m5.776,2.775h-6.551a2.269,2.269,0,0,0,.9,1.462,2.946,2.946,0,0,0,1.806.539,3.045,3.045,0,0,0,2.267-.906l1.047,1.2a3.534,3.534,0,0,1-1.423,1.016,5.634,5.634,0,0,1-4.362-.2,3.938,3.938,0,0,1-1.618-1.524,4.3,4.3,0,0,1-.571-2.212,4.372,4.372,0,0,1,.555-2.2,3.938,3.938,0,0,1,1.54-1.524,4.492,4.492,0,0,1,2.22-.547,4.381,4.381,0,0,1,2.181.539,3.819,3.819,0,0,1,1.5,1.516,4.6,4.6,0,0,1,.539,2.259q0,.2-.031.578",
    transform: "translate(-195.054 -24.478)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    d: "M382.5,53.412a4.981,4.981,0,0,1-1.547-.672l.75-1.485a4.816,4.816,0,0,0,1.352.6,5.621,5.621,0,0,0,1.556.226q1.751,0,1.751-.922a.616.616,0,0,0-.446-.609,7.684,7.684,0,0,0-1.431-.329,11.6,11.6,0,0,1-1.68-.36,2.577,2.577,0,0,1-1.126-.712,1.984,1.984,0,0,1-.477-1.414,2.224,2.224,0,0,1,.993-1.9,4.517,4.517,0,0,1,2.681-.712,7.732,7.732,0,0,1,1.72.2,4.831,4.831,0,0,1,1.407.523l-.75,1.485a4.63,4.63,0,0,0-2.392-.625,2.653,2.653,0,0,0-1.305.258.769.769,0,0,0-.445.68.678.678,0,0,0,.477.664,7.539,7.539,0,0,0,1.478.368,11.432,11.432,0,0,1,1.641.359,2.575,2.575,0,0,1,1.1.688,1.917,1.917,0,0,1,.461,1.375,2.179,2.179,0,0,1-1.016,1.876,4.8,4.8,0,0,1-2.767.7,7.479,7.479,0,0,1-1.985-.266",
    transform: "translate(-206.638 -24.478)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    d: "M400.775,53.412a4.981,4.981,0,0,1-1.548-.672l.75-1.485a4.816,4.816,0,0,0,1.352.6,5.621,5.621,0,0,0,1.556.226q1.751,0,1.751-.922a.616.616,0,0,0-.446-.609,7.682,7.682,0,0,0-1.431-.329,11.6,11.6,0,0,1-1.68-.36,2.577,2.577,0,0,1-1.126-.712,1.984,1.984,0,0,1-.477-1.414,2.224,2.224,0,0,1,.993-1.9,4.516,4.516,0,0,1,2.681-.712,7.732,7.732,0,0,1,1.72.2,4.833,4.833,0,0,1,1.407.523l-.75,1.485a4.63,4.63,0,0,0-2.392-.625,2.654,2.654,0,0,0-1.306.258.769.769,0,0,0-.445.68.679.679,0,0,0,.477.664,7.535,7.535,0,0,0,1.477.368,11.435,11.435,0,0,1,1.641.359,2.574,2.574,0,0,1,1.1.688,1.917,1.917,0,0,1,.461,1.375,2.179,2.179,0,0,1-1.016,1.876,4.8,4.8,0,0,1-2.767.7,7.479,7.479,0,0,1-1.985-.266",
    transform: "translate(-216.553 -24.478)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    d: "M419.277,40.92h1.954v8.348h-1.954Zm.094-1.712a1.153,1.153,0,0,1,0-1.673,1.255,1.255,0,0,1,.891-.336,1.293,1.293,0,0,1,.891.32,1.036,1.036,0,0,1,.36.805,1.179,1.179,0,0,1-.352.868,1.219,1.219,0,0,1-.9.351,1.256,1.256,0,0,1-.891-.336",
    transform: "translate(-227.284 -20.178)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    d: "M434.867,51.285a2.9,2.9,0,0,0,0-3.783,2.387,2.387,0,0,0-1.782-.719,2.361,2.361,0,0,0-1.774.719,2.92,2.92,0,0,0,0,3.783,2.361,2.361,0,0,0,1.774.719,2.387,2.387,0,0,0,1.782-.719M430.8,53.13a3.985,3.985,0,0,1-1.587-1.524,4.558,4.558,0,0,1,0-4.416,4,4,0,0,1,1.587-1.516,5.063,5.063,0,0,1,4.581,0,4,4,0,0,1,1.587,1.516,4.562,4.562,0,0,1,0,4.416,3.989,3.989,0,0,1-1.587,1.524,5.066,5.066,0,0,1-4.581,0",
    transform: "translate(-232.51 -24.477)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    d: "M460.14,46.048a3.642,3.642,0,0,1,.953,2.736v4.784h-1.954V49.035a2.345,2.345,0,0,0-.516-1.649,1.908,1.908,0,0,0-1.469-.555,2.255,2.255,0,0,0-1.7.649,2.583,2.583,0,0,0-.625,1.868v4.222H452.87V45.22h1.86V46.3a3.048,3.048,0,0,1,1.219-.875,4.388,4.388,0,0,1,1.658-.3,3.491,3.491,0,0,1,2.533.922",
    transform: "translate(-245.65 -24.478)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M480.482,51.919a1.83,1.83,0,0,0,.805-.962v-.97H479.27q-1.688,0-1.688,1.11a1,1,0,0,0,.422.845,1.938,1.938,0,0,0,1.173.313,2.528,2.528,0,0,0,1.306-.336m1.782-5.91a3.416,3.416,0,0,1,.977,2.666v4.893H481.4V52.552a2.273,2.273,0,0,1-1.024.836,4.009,4.009,0,0,1-1.6.289,3.926,3.926,0,0,1-1.641-.32,2.532,2.532,0,0,1-1.087-.891,2.262,2.262,0,0,1-.383-1.29,2.21,2.21,0,0,1,.837-1.806,4.151,4.151,0,0,1,2.634-.68h2.158v-.125a1.711,1.711,0,0,0-.524-1.345,2.263,2.263,0,0,0-1.555-.469,4.5,4.5,0,0,0-1.384.219,3.405,3.405,0,0,0-1.149.61l-.766-1.423a4.742,4.742,0,0,1,1.579-.766,7.026,7.026,0,0,1,1.954-.266,4.073,4.073,0,0,1,2.822.883",
    transform: "translate(-258.012 -24.478)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3570",
    "data-name": "Rectangle 3570",
    width: 1.954,
    height: 11.6,
    transform: "translate(228.044 17.49)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M508.4,53.412a4.982,4.982,0,0,1-1.548-.672l.75-1.485a4.817,4.817,0,0,0,1.352.6,5.621,5.621,0,0,0,1.556.226q1.751,0,1.751-.922a.616.616,0,0,0-.446-.609,7.685,7.685,0,0,0-1.431-.329,11.623,11.623,0,0,1-1.681-.36,2.579,2.579,0,0,1-1.126-.712,1.984,1.984,0,0,1-.477-1.414,2.224,2.224,0,0,1,.993-1.9,4.516,4.516,0,0,1,2.681-.712,7.733,7.733,0,0,1,1.72.2,4.832,4.832,0,0,1,1.407.523l-.75,1.485a4.63,4.63,0,0,0-2.392-.625,2.651,2.651,0,0,0-1.305.258.769.769,0,0,0-.445.68.678.678,0,0,0,.477.664,7.537,7.537,0,0,0,1.478.368,11.436,11.436,0,0,1,1.641.359,2.575,2.575,0,0,1,1.1.688,1.917,1.917,0,0,1,.461,1.375,2.178,2.178,0,0,1-1.016,1.876,4.8,4.8,0,0,1-2.767.7,7.479,7.479,0,0,1-1.985-.266",
    transform: "translate(-274.933 -24.478)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M288.626,79.916,290.69,84.7h-4.112Zm-.985-2.033-4.924,10.944h2.095l1.078-2.533h5.472l1.095,2.533h2.126l-4.94-10.944Z",
    transform: "translate(-153.354 -42.246)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3571",
    "data-name": "Rectangle 3571",
    width: 1.954,
    height: 11.6,
    transform: "translate(142.745 34.981)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3572",
    "data-name": "Rectangle 3572",
    width: 1.954,
    height: 11.6,
    transform: "translate(147.576 34.981)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M332.764,79.144h1.954v8.348h-1.954Zm.094-1.712a1.152,1.152,0,0,1,0-1.673,1.255,1.255,0,0,1,.891-.336,1.293,1.293,0,0,1,.891.32,1.035,1.035,0,0,1,.36.805,1.179,1.179,0,0,1-.352.868,1.219,1.219,0,0,1-.9.351,1.257,1.257,0,0,1-.891-.336",
    transform: "translate(-180.357 -40.912)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M347.16,90.143a1.831,1.831,0,0,0,.805-.962v-.97h-2.017q-1.688,0-1.688,1.11a1,1,0,0,0,.422.845,1.938,1.938,0,0,0,1.173.313,2.528,2.528,0,0,0,1.305-.336m1.782-5.91a3.416,3.416,0,0,1,.977,2.666v4.893h-1.844V90.776a2.273,2.273,0,0,1-1.024.836,4.009,4.009,0,0,1-1.6.289,3.925,3.925,0,0,1-1.641-.32,2.532,2.532,0,0,1-1.087-.891,2.261,2.261,0,0,1-.383-1.29,2.21,2.21,0,0,1,.837-1.806,4.152,4.152,0,0,1,2.634-.68h2.158V86.79a1.712,1.712,0,0,0-.524-1.345,2.267,2.267,0,0,0-1.556-.469,4.5,4.5,0,0,0-1.384.219,3.4,3.4,0,0,0-1.149.61l-.766-1.423a4.743,4.743,0,0,1,1.579-.766,7.026,7.026,0,0,1,1.954-.266,4.074,4.074,0,0,1,2.822.883",
    transform: "translate(-185.694 -45.212)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M372.329,84.272a3.64,3.64,0,0,1,.954,2.736v4.784h-1.954V87.259a2.343,2.343,0,0,0-.516-1.649,1.906,1.906,0,0,0-1.469-.555,2.256,2.256,0,0,0-1.7.649,2.585,2.585,0,0,0-.625,1.868v4.222h-1.954V83.444h1.861v1.079a3.049,3.049,0,0,1,1.219-.875,4.385,4.385,0,0,1,1.657-.3,3.49,3.49,0,0,1,2.533.922",
    transform: "translate(-198.019 -45.212)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    "data-name": "Path 3919",
    d: "M390,91.354a4.014,4.014,0,0,1-1.61-1.524,4.5,4.5,0,0,1,0-4.416,4.042,4.042,0,0,1,1.6-1.516,4.878,4.878,0,0,1,2.337-.548,4.5,4.5,0,0,1,2.165.5,3.25,3.25,0,0,1,1.4,1.438l-1.5.875a2.388,2.388,0,0,0-.9-.868,2.623,2.623,0,0,0-2.994.422,2.879,2.879,0,0,0-.008,3.8,2.635,2.635,0,0,0,3,.422,2.381,2.381,0,0,0,.9-.868l1.5.875a3.382,3.382,0,0,1-1.415,1.446,4.409,4.409,0,0,1-2.15.508A4.891,4.891,0,0,1,390,91.354",
    transform: "translate(-210.362 -45.211)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3920",
    "data-name": "Path 3920",
    d: "M410.8,85.468a2.332,2.332,0,0,0-.79,1.478h4.737a2.282,2.282,0,0,0-2.361-2.033,2.359,2.359,0,0,0-1.586.555m5.776,2.775h-6.551a2.269,2.269,0,0,0,.9,1.462,2.946,2.946,0,0,0,1.806.539A3.045,3.045,0,0,0,415,89.338l1.047,1.2a3.534,3.534,0,0,1-1.423,1.016,5.634,5.634,0,0,1-4.362-.2,3.94,3.94,0,0,1-1.618-1.524,4.3,4.3,0,0,1-.571-2.212,4.373,4.373,0,0,1,.555-2.2,3.939,3.939,0,0,1,1.54-1.524,4.491,4.491,0,0,1,2.22-.547,4.381,4.381,0,0,1,2.181.539,3.819,3.819,0,0,1,1.5,1.516,4.6,4.6,0,0,1,.539,2.259c0,.135-.01.329-.031.578",
    transform: "translate(-221.352 -45.212)",
    fill: "#253038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M433.6,86.1l-.006-2.636h-.47l-1.1,1.689-1.118-1.689h-.47V86.1h.552V84.47l.9,1.34h.267l.889-1.372.006,1.664Zm-5.964-2.172h.927V86.1h.584V83.931h.927v-.464h-2.439Z",
    transform: "translate(-231.962 -45.275)",
    fill: "#253038"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpaLogo);
export default __webpack_public_path__ + "static/media/hpaLogo.c46457db.svg";
export { ForwardRef as ReactComponent };